import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ComingSoon from "./pages/comingSoon/ComingSoon";
import Qr from "./pages/qr/Qr";

import Navbar from "./components/navbar/Navbar";
import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Services from "./pages/services/Services";
import ContactUs from "./pages/contactUs/ContactUs";
import BookADemo from "./pages/bookADemo/BookADemo";
import { ROUTES_NAME } from "./constants/routes";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";
import CommonHeader from "./components/commonComponents/commonHeader/CommonHeader";
import Simulations from "./pages/simulations/Simulations";
import { ToastContainer } from "react-toastify";
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./pages/termsAndConditions/TermsAndConditions";


function AppLayout() {
  const location = useLocation();
  const pathname = location.pathname;

  const shouldHideLayoutForPath = (path) => {
    const hiddenPathPrefixes = ["/simulations",]; 
  return hiddenPathPrefixes.some((prefix) => path.startsWith(prefix));
  };

  const shouldHideLayout = shouldHideLayoutForPath(pathname);
  const isHomePage = pathname === "/";
  const isQrPage = pathname === "/qr";

  return (
    <div className="overflow-hidden font-outfitMedium text-defaultText">
      <ToastContainer />
      {!shouldHideLayout && <Navbar />}
      <ScrollToTop />
      {!shouldHideLayout && <div className="bg-red-50 h-16"></div>}
      {!shouldHideLayout && !isHomePage && !isQrPage && <CommonHeader />}

      <Routes>
        <Route path={ROUTES_NAME.HOME} element={<Home />} />
        <Route path={ROUTES_NAME.ABOUT} element={<About />} />
        <Route path={ROUTES_NAME.SERVICES} element={<Services />} />
        <Route path={ROUTES_NAME.CONTACT_US} element={<ContactUs />} />
        <Route path={ROUTES_NAME.BOOK_A_DEMO} element={<BookADemo />} />
        <Route path={ROUTES_NAME.SIMULATION} element={<Simulations />} />
        <Route path={ROUTES_NAME.PRIVACY_POLICY} element={<PrivacyPolicy />} />
        <Route path={ROUTES_NAME.TERMS_AND_CONDITIONS} element={<TermsAndConditions />} />
        <Route path="/qr" element={<Home />} />
      </Routes>

      {!shouldHideLayout && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
